import React from 'react';
import { MedicalForm } from './pages/MedicalForm';
export function App() {
  return <MedicalForm data-id="element-0" />;
}